var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-element-loading',{attrs:{"active":_vm.active,"is-full-screen":true,"color":"#FF5C67"}},[_c('img',{staticClass:"loading-gif",attrs:{"src":require("@/assets/images/loading.gif"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }